import React from 'react';
import { I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import MultiselectFilter from 'components/Filter/MultiselectFilter';
import SearchField from 'components/SearchField';
import FlexGroup from 'components/FlexGroup';
import DatetimeRangeFilter from 'components/Filter/DatetimeRangeFilter';
import moment from 'moment';

import {
    NONUSER_CHARGE_EXPENSE_TYPE_GROUP,

    NONUSER_CHARGE_STATUS_SUCCESS,
    NONUSER_CHARGE_STATUS_UNPAID,
    NONUSER_CHARGE_STATUS_FAILED,
    NONUSER_CHARGE_STATUS_REVOKED,
} from 'constants/nonuser-charge';

export const KEYWORD = 'keyword';
export const EXPENSE_TYPE = 'expense_type';
export const STATUS = 'status';
export const CREATE_TIME = 'create_time';
export const defaultRange = [30, 'days'];

export const getNonuserExpenseTypeOptions = () => [
    ...NONUSER_CHARGE_EXPENSE_TYPE_GROUP,
].map(
    value => ({
        text: I18n.t(`nonuser_charge.nonuser_expense_type_map.${ value }`),
        value,
    })
);

export const getNonuserChargeStatusOptions = () => [
    NONUSER_CHARGE_STATUS_UNPAID,
    NONUSER_CHARGE_STATUS_SUCCESS,
    NONUSER_CHARGE_STATUS_FAILED,
    NONUSER_CHARGE_STATUS_REVOKED
].map(
    value => ({
        text: I18n.t(`nonuser_charge.nonuser_charge_status_map.${ value }`),
        value,
    })
);



export const getDefaultPeriod = () => {
    return {
        start: moment().subtract(...defaultRange).format('YYYY-MM-DD'),
        end: moment().startOf('day').add(1, 'd'),
    };
};

const NonUserChargeFilter = ({
    onChangeKeyword,
    applyFilter,
    value,
    appliedDateRange,
    filter,
}) => {
    return (
        <FlexGroup start>
            <SearchField
                placeholder={ I18n.t('nonuser_charge.case_name') }
                onChange={ onChangeKeyword }
                onSubmit={ applyFilter(KEYWORD) }
                value={ value }
            />
            <section className="filters">
                <MultiselectFilter
                    title={ I18n.t('nonuser_charge.status') }
                    options={ getNonuserChargeStatusOptions() }
                    defaultSelected={ filter[STATUS] }
                    onChange={ applyFilter(STATUS) }
                />
                <DatetimeRangeFilter
                    range={ defaultRange }
                    title={ I18n.t('customer.create_time') }
                    defaultFrom={ filter.create_from }
                    defaultTo={ filter.create_to }
                    onApply={ applyFilter(CREATE_TIME) }
                    applied={ appliedDateRange }
                />
                <MultiselectFilter
                    title={ I18n.t('nonuser_charge.expense_type') }
                    options={ getNonuserExpenseTypeOptions() }
                    defaultSelected={ filter[EXPENSE_TYPE] }
                    onChange={ applyFilter(EXPENSE_TYPE) }
                />
            </section>
        </FlexGroup>
    );
};

NonUserChargeFilter.propTypes = {
    onChangeKeyword: PropTypes.func,
    applyFilter: PropTypes.func,
    value: PropTypes.string,
    appliedDateRange: PropTypes.bool,
    filter: PropTypes.shape(),
};

NonUserChargeFilter.defaultProps = {
    applyFilter: () => {},
    onChangeKeyword: () => {},
    value: undefined,
    appliedDateRange: false,
    filter: undefined,
};

export default NonUserChargeFilter;
